import React from 'react';

import styles from './NewMessageFormStyles';

import { MessageFormErrors } from 'buyside/components/presentation/MessageForm/MessageForm';

export const SubjectError = () => (
  <MessageFormErrors>
    {({ errors }) => <div className={styles.errorStyle}>{errors.subject}</div>}
  </MessageFormErrors>
);

export const UserError = () => (
  <MessageFormErrors>
    {({ errors }) => <div className={styles.errorStyle}>{errors.receiverUserId}</div>}
  </MessageFormErrors>
);

export const BodyError = () => (
  <MessageFormErrors>
    {({ errors }) => <div className={styles.errorStyle}>{errors.body}</div>}
  </MessageFormErrors>
);
